import React, { useEffect, useState } from 'react'
import MainLayout from '../layouts/MainLayout'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import BreadCrums from '../components/BreadCrums'
import Loader from '../components/Loader'
import { Api, BaseUrl, ImagePath } from '../config/apiEndPoints'
import { callApi } from '../config/apiCall'
import { toast } from 'react-toastify'
import AddPolices from '../components/AddPolices'
import ViewRequestDetails from '../components/ViewRequestDetails'
import TableComponent from "../components/TableComponent";
import axios from 'axios'
import { getCompanies, getManagePolicyData } from '../redux/actions/dashBoardActions'
import { AiOutlineMail } from 'react-icons/ai'
import { FaChevronDown } from 'react-icons/fa'
import { MultiSelect } from 'primereact/multiselect'

function PolicyManage() {
    const dispatch = useDispatch()
    const [emails, setEmails] = useState([]);
    const [currentEmail, setCurrentEmail] = useState("");
    const [searchText, setSearchText] = useState("")
    const companiesData = useSelector((state) => state.commenData?.companiesData)
    const companyPolicy = useSelector((state) => state.commenData?.companyPolicy)
    const [modalData, setModalData] = useState({ isOpen: false, data: "" })
    const [currentId, setCurrentId] = useState()
    const [branches, setBranches] = useState([]);
    const [currentBranche, setCurrentBranch] = useState("");
    const details = JSON.parse(sessionStorage.getItem("userDetails")) || {}
    const [formData, setFormData] = useState({
        companyId: "",
        policy_id: null,
        companyData: {},
        status: "",
        working_days: [],
        weekoff_days: [],
        late_allowed: 0,
        max_late_time: 0,
        probation_period: 3,
        probation_leave_deduction: 1,
        unapproved_deduction: 1,
        half_day: 0,
        monthly_leave: 1,
        yearly_leave: 12,
        holidays_leave: 0,
        // cc_emails: ["ashishkumar@gmail.com"],
        hr_email: "",
        mail_host: "",
        mail_port: "",
        mail_username: "",
        mail_password: "",
        branches: [],
        gst_no: "",
        bank_name: "",
        bank_ac: "",
        swift_code: "",
        bank_address: "",
        zip_code: "",
        authorized_signature_url: "",
        authorized_person_name: "",
        authorized_person_designation: "",
        shifts: [{
            id: null,
            name: "",
            start_time: "",
            end_time: "",
            break_start: "",
            break_end: "",
            status: "",
        }]
    });
    const policyFormFields = [
        // { key: "companyId", title: "Company ID",disable:true },
        { key: "status", title: "Status", selectBox: true },
        { key: "probation_period", title: "Probation Period (Months)", type: "number" },
        // { key: "working_days", title: "Working Days" },
        // { key: "weekoff_days", title: "Weekoff Days" },
        { key: "late_allowed", title: "Late Allowed", type: "number" },
        // { key: "max_late_time", title: "Max Late Time" },
        { key: "probation_leave_deduction", title: "Probation Leave Deduction", type: "number" },
        { key: "unapproved_deduction", title: "Unapproved Deduction", type: "number" },
        { key: "half_day", title: "Half Day Deduction" },
        { key: "monthly_leave", title: "Monthly Leave" },
        { key: "yearly_leave", title: "Yearly Leave" },
        { key: "holidays_leave", title: "Holiday Leave" },
        // { key: "cc_emails", title: "CC Emails", type: "email" },
        { key: "hr_email", title: "HR Email", type: "email" },
        { key: "mail_host", title: "Mail Host" },
        { key: "mail_port", title: "Mail Port" },
        { key: "mail_username", title: "Mail Username" },
        { key: "mail_password", title: "Mail Password", type: "password" },
        // { key: "branches", title: "Branches" ,isArray:true },
        { key: "gst_no", title: "GST Number" },
        { key: "bank_name", title: "Bank Name", type: "text" },
        { key: "bank_ac", title: "Bank Account Number", type: "number" },
        { key: "swift_code", title: "SWIFT Code" },
        { key: "bank_address", title: "Bank Address" },
        { key: "zip_code", title: "ZIP Code", type: "number" },
        // { key: "authorized_signature_url", title: "Authorized Signature URL" },
        // { key: "shifts", title: "Shift Timings" }
    ];
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        dispatch(getCompanies({ limit: 1000 }))
    }, [])

    useEffect(() => {
        if (companiesData?.data) {
            dispatch(getManagePolicyData(companiesData?.data[0]?.id))
            setCurrentId(companiesData?.data[0])
        }
    }, [companiesData])

    useEffect(() => {
        // //console.log(formData);
        const { id, created_at, updated_at, ...rest } = companyPolicy
        setFormData({
            ...rest,
            policy_id: id,
            shifts: rest?.shifts?.map((item) => {
                let { created_at, updated_at, shift_duration, ...needKeys } = item
                return needKeys
            })
        })
        setBranches(rest?.branches || [])
        setEmails(rest?.cc_emails || [])

    }, [companyPolicy])

    const validateTimeFields = (fieldName, value, row) => {
        switch (fieldName) {
            case 'start_time':
                if (row.end_time && value > row.end_time) {
                    toast.error('Start Time cannot be after End Time');
                    return false;
                }
                break;
            case 'end_time':
                if (row.start_time && value < row.start_time) {
                    toast.error('End Time cannot be before Start Time');
                    return false;
                }
                break;
            case 'break_start':
                if (row.break_end && value > row.break_end) {
                    toast.error('Break Start Time cannot be after Break End Time');
                    return false;
                }
                break;
            case 'break_end':
                if (row.break_start && value < row.break_start) {
                    toast.error('Break End Time cannot be before Break Start Time');
                    return false;
                }
                break;
            default:
                return true;
        }
        return true;
    };



    const handleChange = (e, arrayKey, index = null) => {
        const { name, value, type } = e.target;

        if (type === "file") {
            setFormData((prevData) => ({
                ...prevData,
                [name]: e.target.files[0],
            }));
        } else {
            if (arrayKey === "shifts" && index !== null) {
                // Handle nested field inside shifts array
                setFormData((prevData) => {
                    const updatedShifts = [...prevData.shifts];
                    updatedShifts[index] = {
                        ...updatedShifts[index],
                        [name]: value,
                    };

                    return {
                        ...prevData,
                        shifts: updatedShifts,
                    };
                });
            } else {
                // Handle top-level fields
                setFormData((prevData) => ({
                    ...prevData,
                    [name]: value,
                }));
            }
        }
    };


    const handleEditToggle = () => {
        setIsEdit(!isEdit);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const data = new FormData()
            let arraykey = ["working_days", "branches", "weekoff_days", "shifts"]
            Object.entries(formData)?.map(([key, value]) => {
                if (arraykey.includes(key)) {
                    data.append(key, JSON.stringify(value))
                } else {
                    data.append(key, value)
                }
            })
            data.append("branches", JSON.stringify(branches))
            data.append("cc_emails", JSON.stringify(emails))
            const response = await callApi(`/super-admin/companies/${currentId?.id}/policies`, "POST", data, details?.token);
            // //console.log("response", response);
            if (response?.success) {
                setIsEdit(false)
                toast.success(response?.message)
            } else {
                toast.error(response?.message)
            }

            // alert('Form submitted successfully');
            setIsEdit(false);
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message)
            console.error(error);
            // alert('Failed to submit');
        }
    };

    const isLoading = false

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault(); // Prevent default comma behavior in input
            addBranche();
        }
    };

    const addBranche = () => {
        const trimmedEmail = currentBranche.trim();
        if (trimmedEmail) {
            if (!branches.includes(trimmedEmail)) {
                setBranches([...branches, trimmedEmail]);
                setCurrentBranch(""); // Clear input field
            } else {
                alert("This branche is already added!");
            }
        } else if (trimmedEmail) {
            alert("Invalid branches !");
        }
    };

    const removeBranche = (emailToRemove) => {
        setBranches(branches.filter((bname) => bname !== emailToRemove));
    };


    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleKeyDownEmail = (e) => {
        if (e.key === "Enter" || e.key === ",") {
            e.preventDefault(); // Prevent default comma behavior in input
            addEmail();
        }
    };

    const addEmail = () => {
        const trimmedEmail = currentEmail.trim();
        if (trimmedEmail && isValidEmail(trimmedEmail)) {
            if (!emails.includes(trimmedEmail)) {
                setEmails([...emails, trimmedEmail]);
                setCurrentEmail(""); // Clear input field
            } else {
                alert("This email is already added!");
            }
        } else if (trimmedEmail) {
            alert("Invalid email address!");
        }
    };

    const removeEmail = (emailToRemove) => {
        setEmails(emails.filter((email) => email !== emailToRemove));
    };

    const options = [
        { name: "Monday", code: "Monday" },
        { name: "Tuesday", code: "Tuesday" },
        { name: "Wednesday", code: "Wednesday" },
        { name: "Thursday", code: "Thursday" },
        { name: "Friday", code: "Friday" },
        { name: "Saturday", code: "Saturday" },
        { name: "Sunday", code: "Sunday" }
    ]

    return (
        <React.Fragment>
            <MainLayout>
                <div className="page-wrapper">
                    {
                        isLoading ?
                            <Loader /> :
                            <div className="content">
                                <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb m-0">
                                    <BreadCrums
                                        title={"Manage Policy"}
                                        data={[
                                            { path: "/superadmin/", title: "Superadmin" },
                                            { path: "/", title: "Manage Policy" },

                                        ]}
                                    />
                                    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="card p-3">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <h5>Policy Details</h5>
                                                <button className="btn btn-primary btn-sm" onClick={handleEditToggle}>
                                                    {isEdit ? 'Cancel' : 'Edit'}
                                                </button>
                                            </div>
                                            <form onSubmit={handleSubmit}>
                                                <div className="d-flex align-items-center mb-3">
                                                    <div className="avatar me-3">
                                                        <img src={currentId?.company_logo ? ImagePath + currentId?.company_logo : "/assets/img/user.png"} alt="Company Logo" />
                                                    </div>
                                                    <div>
                                                        <h6 className="mb-0">{currentId?.company_name}</h6>
                                                        <small>{currentId?.admin_email || ""}</small>
                                                    </div>
                                                </div>
                                                <div className='py-3'>
                                                    <p className='text-dark fs-20'>Info</p>
                                                </div>

                                                <div className="row g-3">
                                                    {policyFormFields.map((field, index) => {
                                                        if (field?.selectBox) {
                                                            return (
                                                                <div className="col-md-6" key={index}>
                                                                    <label className="form-label">{field?.title || ""}</label>
                                                                    <select
                                                                        // type="text"
                                                                        className="form-control"
                                                                        name={field?.key}
                                                                        value={formData[field?.key]}
                                                                        disabled={!isEdit}
                                                                        onChange={handleChange}
                                                                    >
                                                                        <option value={""}>Selcet</option>
                                                                        <option value={"Active"}>Active</option>
                                                                        <option value={"Inactive"}>Inactive</option>

                                                                    </select>
                                                                </div>
                                                            )
                                                        } else {
                                                            return (
                                                                <div className="col-md-6" key={index}>
                                                                    <label className="form-label">{field?.title || ""}</label>
                                                                    <input
                                                                        // type="text"
                                                                        className="form-control"
                                                                        name={field?.key}
                                                                        type={field?.type || "text"}
                                                                        value={formData[field?.key]}
                                                                        disabled={!isEdit}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                            )
                                                        }
                                                    })}


                                                </div>
                                                <div className="row g-3 py-2">
                                                    <div className="col-md-6">
                                                        <label className="form-label">Working days</label>
                                                        <MultiSelect
                                                            value={
                                                                options?.filter((opt) => formData.working_days?.includes(opt.name)) || []
                                                            } // Match selected names to options
                                                            options={options}
                                                            onChange={(e) => {
                                                                const selectedNames = e.value.map((item) => item.name); // Extract and store names
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    working_days: selectedNames || []
                                                                }))
                                                            }}
                                                            optionLabel="name"
                                                            placeholder="Select Days"
                                                            className="w-full md:w-20rem"
                                                            display="chip"
                                                            dropdownIcon={<FaChevronDown style={{ marginLeft: 30 }} />}
                                                        />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="form-label">WeekOff days</label>
                                                        <MultiSelect
                                                            value={
                                                                // formData?.weekoff_days
                                                                options?.filter((opt) => formData?.weekoff_days?.includes(opt.name)) || []
                                                            } // Match selected names to options
                                                            options={options}
                                                            onChange={(e) => {
                                                                const selectedNames = e.value.map((item) => item.name); // Extract and store names
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    weekoff_days: selectedNames
                                                                }))
                                                                // //console.log(formData?.weekoff_days);
                                                                // setSelectedOptions(selectedNames);
                                                            }}
                                                            optionLabel="name"
                                                            placeholder="Select Days"
                                                            className="w-full md:w-20rem"
                                                            display="chip"
                                                            dropdownIcon={<FaChevronDown style={{ marginLeft: 30 }} />}
                                                        />

                                                    </div>
                                                </div>
                                                <div className="row g-3 py-2">
                                                    <div className="col-12">
                                                        <label className="form-label">CC Emails</label>
                                                        <div className="email-input-container">
                                                            <div className="email-input-wrapper">
                                                                <span className="icon">
                                                                    <AiOutlineMail color={"black"} />
                                                                </span>
                                                                {emails?.map((email, index) => (
                                                                    <div key={index} className="email-tag">
                                                                        <span>{email}</span>
                                                                        <button type="button" onClick={() => removeEmail(email)}>
                                                                            &times;
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                                <input
                                                                    type="text"
                                                                    value={currentEmail}
                                                                    onChange={(e) => setCurrentEmail(e.target.value)}
                                                                    onKeyDown={handleKeyDownEmail}
                                                                    placeholder="Enter email addresses"
                                                                />
                                                            </div>
                                                            {/* </div> */}
                                                        </div>
                                                    </div>
                                                    <div className="col-12">
                                                        <label className="form-label">Branches</label>
                                                        <div className="email-input-container">
                                                            <div className="email-input-wrapper">
                                                                {branches?.map((bname, index) => (
                                                                    <div key={index} className="email-tag">
                                                                        <span>{bname}</span>
                                                                        <button type="button" onClick={() => removeBranche(bname)}>
                                                                            &times;
                                                                        </button>
                                                                    </div>
                                                                ))}
                                                                <input
                                                                    type="text"
                                                                    title='Please press enter for next entry'
                                                                    value={currentBranche}
                                                                    disabled={!isEdit}
                                                                    onChange={(e) => setCurrentBranch(e.target.value)}
                                                                    onKeyDown={handleKeyDown}
                                                                    placeholder="Enter Branches name"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row g-3'>
                                                    <div >
                                                        <b className='fs-20 bold text-dark pl-1 py-2'>Shift</b>
                                                    </div>
                                                    {
                                                        formData.shifts?.map((sRow, index) => {
                                                            return (
                                                                <div className="row " key={index}>
                                                                    <div className="col-md-3">
                                                                        <label className="form-label">Name</label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            name="name"
                                                                            placeholder='Enter shift name e.g Day Shift '
                                                                            value={sRow?.name}
                                                                            disabled={!isEdit}
                                                                            onChange={(e) => {
                                                                                // if (!validateTimeFields(name, value, updatedRow)) return;
                                                                                handleChange(e, "shifts", index)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label className="form-label">Start Time</label>
                                                                        <input
                                                                            type="time"
                                                                            className="form-control"
                                                                            name="start_time"
                                                                            value={sRow?.start_time}
                                                                            disabled={!isEdit}
                                                                            onChange={(e) => {
                                                                                if (!validateTimeFields("start_time", e.target.value, sRow)) return;
                                                                                handleChange(e, "shifts", index)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3">
                                                                        <label className="form-label">End Time</label>
                                                                        <input
                                                                            type="time"
                                                                            className="form-control"
                                                                            name="end_time"
                                                                            value={sRow?.end_time}
                                                                            disabled={!isEdit}
                                                                            onChange={(e) => {
                                                                                if (!validateTimeFields("end_time", e.target.value, sRow)) return;
                                                                                handleChange(e, "shifts", index)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 ">
                                                                        <label className="form-label">Break Start Time</label>
                                                                        <input
                                                                            type="time"
                                                                            className="form-control"
                                                                            name="break_start"
                                                                            value={sRow?.break_start}
                                                                            disabled={!isEdit}
                                                                            onChange={(e) => {
                                                                                if (!validateTimeFields("break_start", e.target.value, sRow)) return;
                                                                                handleChange(e, "shifts", index)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 pt-2">
                                                                        <label className="form-label">Break End Time</label>
                                                                        <input
                                                                            type="time"
                                                                            className="form-control"
                                                                            name="break_end"
                                                                            value={sRow?.break_end}
                                                                            disabled={!isEdit}
                                                                            onChange={(e) => {
                                                                                if (!validateTimeFields("break_end", e.target.value, sRow)) return;
                                                                                handleChange(e, "shifts", index)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-md-3 pt-2">
                                                                        <label className="form-label">Status</label>
                                                                        <select
                                                                            className="form-control"
                                                                            name="status"
                                                                            value={sRow?.status}
                                                                            disabled={!isEdit}
                                                                            onChange={(e) => {
                                                                                handleChange(e, "shifts", index)
                                                                            }}
                                                                        >
                                                                            <option value="">Select</option>
                                                                            <option value="Active">Active</option>
                                                                            <option value="Inactive">Inacive</option>
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-md-2 d-flex gap-3 align-items-end pb-2">
                                                                        <a className='' onClick={() => {
                                                                            if (formData.shifts?.length == 2) {
                                                                                toast.warning("You can add maximum two shifts !")
                                                                                return
                                                                            }
                                                                            setFormData((prev) => ({
                                                                                ...prev,
                                                                                shifts: [...prev.shifts, {
                                                                                    id: null,
                                                                                    name: "",
                                                                                    start_time: "",
                                                                                    end_time: "",
                                                                                    break_start: "",
                                                                                    break_end: "",
                                                                                    status: "",
                                                                                }]
                                                                            }))
                                                                        }}>
                                                                            <i className='fa fa-plus-circle fs-20 text-success' />
                                                                        </a>
                                                                        {/* {} */}
                                                                        {
                                                                            formData?.shifts?.length > 1 &&
                                                                            <a className='' onClick={() => {
                                                                                if (formData?.shifts?.length > 1) {
                                                                                    setFormData((prev) => ({
                                                                                        ...prev,
                                                                                        shifts: prev.shifts?.filter((it, shilft_index) => {
                                                                                            return shilft_index != index
                                                                                        })
                                                                                    }))
                                                                                }
                                                                            }}>
                                                                                <i className='fa fa-trash fs-20 text-error' />
                                                                            </a>
                                                                        }
                                                                    </div>


                                                                </div>
                                                            )
                                                        })
                                                    }

                                                </div>
                                                <div className='row g-3 pt-2'>
                                                    <div >
                                                        <b className='fs-20 bold text-dark pl-1 py-2'>
                                                            Signature
                                                        </b>
                                                    </div>

                                                    <div className="row " >

                                                        <div className="col-md-6">
                                                            <label className="form-label">Signature Name</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="authorized_person_name"
                                                                value={formData?.authorized_person_name || ""}
                                                                disabled={!isEdit}
                                                                placeholder='Enter Signature Name'
                                                                onChange={(e) => {
                                                                    handleChange(e)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label className="form-label">Designation</label>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                name="authorized_person_designation"
                                                                placeholder='Enter Designation '
                                                                value={formData?.authorized_person_designation || ""}
                                                                disabled={!isEdit}
                                                                onChange={(e) => {
                                                                    handleChange(e)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 pt-2">
                                                            <label className="form-label">Upload Signature</label>
                                                            <input
                                                                type="file"
                                                                className="form-control"
                                                                name="authorized_signature_url"
                                                                disabled={!isEdit}
                                                                onChange={(e) => {
                                                                    handleChange(e)
                                                                }}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 pt-2 ">
                                                            <div className='border p-1'>
                                                                {
                                                                    formData?.authorized_signature_url &&
                                                                    <img
                                                                        className='w-40'
                                                                        src={
                                                                            formData.authorized_signature_url instanceof File
                                                                                ? URL.createObjectURL(formData.authorized_signature_url)
                                                                                : ImagePath + formData.authorized_signature_url
                                                                        }
                                                                        alt="signature"
                                                                    />
                                                                }
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>

                                                {isEdit && (
                                                    <div className="text-end mt-3">
                                                        <button type="submit" className="btn btn-success">
                                                            Save
                                                        </button>
                                                    </div>
                                                )}
                                            </form>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div className="card p-3" style={{
                                            minHeight: "100vh",
                                            overflow: "auto"
                                        }}>
                                            <h6 className='pb-2'>Company Name</h6>
                                            <div>
                                                <input type="text" onChange={(e) => {
                                                    setSearchText(e.target.value)
                                                }} className="form-control mb-3" placeholder="Search" />
                                            </div>
                                            <ul className="list-group company-list ">
                                                {companiesData?.data?.filter((item) => {
                                                    // //console.log(item);
                                                    if (searchText) {
                                                        return item?.company_name?.toLowerCase().includes(searchText?.toLowerCase())
                                                    }
                                                    return item
                                                }).map((comDet, index) => (
                                                    <li
                                                        style={{
                                                            minHeight: "75px"
                                                        }}
                                                        onClick={() => {
                                                            dispatch(getManagePolicyData(comDet?.id))
                                                            setCurrentId(comDet)
                                                        }}
                                                        className={`list-group-item ${currentId?.id === comDet?.id ? 'active' : ''}`}
                                                        key={index}
                                                    >
                                                        <img  className='w-14 h-14 border img-fluid rounded-full' style={{
                                                            width:"40px",
                                                            height:"40px",
                                                            objectFit:"cover"
                                                        }} 
                                                        src={comDet?.company_logo ? ImagePath + comDet?.company_logo : "/assets/img/user.png"} alt='img' />
                                                        <b className='gray'>
                                                            {comDet?.company_name || ""}({comDet?.company_id})
                                                        </b>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                    }
                </div>
            </MainLayout>
            {
                modalData.isOpen && (modalData.type == "add" || modalData.type == "edit") &&
                <AddPolices handleData={modalData} />
            }
        </React.Fragment>
    )
}

export default PolicyManage
